import { debounce } from "@pharaday/utils";
import { type Query, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

type UseDebounceResetQueryClientOptions = {
  predicate?: (query: Query) => boolean;
};

const useDebounceResetQueryClient = ({ predicate }: UseDebounceResetQueryClientOptions) => {
  const queryClient = useQueryClient();
  return useCallback(
    debounce(() => queryClient.resetQueries({ predicate }), 100),
    [queryClient, predicate]
  );
};

export default useDebounceResetQueryClient;
